'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { noteVisitedPath } from '@/lib/seller-source-capture';

/**
 * Notes each page the app shows, so a product or storefront reached later in
 * the same tab knows whether the buyer had been browsing supa.place (a
 * discovery page) first. See seller-source-capture.ts, rule 3. Stores nothing
 * and renders nothing.
 */
export function SellerSourceTracker() {
  const pathname = usePathname();
  useEffect(() => {
    if (pathname) noteVisitedPath(pathname);
  }, [pathname]);
  return null;
}
